import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useMediaQuery } from 'react-responsive';
import cN from 'classnames';
import * as Interface from '@Redux/detail/Group/interfaces';
import { RootState } from '@Redux/detail/store';
import { setCalendarGroupsMode } from '@Redux/detail/Group/actions';
import { List, Calendar } from '@components/Common/Icons';
import styles from './styles.module.scss';

const GroupAllModeswitcher: React.FC<Interface.I_GroupAllModeswitcher> = () => {
    const { CalendarGroups } = useSelector((state: RootState) => state.calendarInfoReducer);

    const { isListMode } = CalendarGroups;
    const isMobile = useMediaQuery({ query: '(max-width: 980px)' });

    const dispatch = useDispatch();

    const clickGroupAllModeswitcher = () => {
        dispatch(setCalendarGroupsMode(!isListMode));
    };

    useEffect(() => {
        if (isMobile) {
            dispatch(setCalendarGroupsMode(true));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isMobile]);

    return (
        <div
            className={cN(styles['group_all_modeSwitcher'], 'group_all_modeSwitcher')}
            onClick={clickGroupAllModeswitcher}
        >
            {isListMode ? <Calendar fill="#222" /> : <List fill="#222" />}
            <div className={styles['text']}>{isListMode ? '月曆顯示' : '列表顯示'}</div>
        </div>
    );
};

export default GroupAllModeswitcher;
